import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

const FAQ_KEYS = ["trial", "change_plan", "per_user", "branded_app", "setup_fee", "discounts", "match_ai", "mcp"] as const;

export function PricingFaq() {
	const { t } = useTranslation("pricing");

	return (
		<div className="mx-auto max-w-3xl">
			<h2 className="text-center text-balance text-3xl font-bold tracking-tight text-foreground md:text-4xl">{t("faq.title")}</h2>
			<div className="mt-10 divide-y divide-default-200/60 rounded-3xl border border-default-200 bg-white shadow-card">
				{FAQ_KEYS.map((key) => (
					<details key={key} className="group px-6 py-5 [&_summary::-webkit-details-marker]:hidden">
						<summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left text-base font-semibold text-foreground">
							<span>{t(`faq.items.${key}.question`)}</span>
							<ChevronDown className="h-5 w-5 shrink-0 text-default-500 transition-transform group-open:rotate-180" />
						</summary>
						<p className="mt-3 text-sm leading-relaxed text-default-600">{t(`faq.items.${key}.answer`)}</p>
					</details>
				))}
			</div>
		</div>
	);
}
